// Moves one sub-ticket to the position it was dropped on.
//
// Operates on IDs only, never on rows: the server owns the order and the whole ID list is what the
// reorder endpoint accepts, so producing the proposed list here and letting the server return the
// authoritative one keeps a single source of truth. Nothing about a phase's identity moves — the
// immutable `#ordinal` label is not part of this at all.
//
// A malformed target fails closed. React DnD supplies an exact rendered row index; silently
// clamping anything else would turn a stale or corrupt hover into a different order than the hand
// selected.
//
// A move that changes nothing returns the SAME array, so the caller can detect "there is nothing
// to submit" by identity and leave the endpoint alone.
export const moveSubTicketToIndex = (ids: ID[], subTicketId: ID, targetIndex: number): ID[] => {
    const from = ids.indexOf(subTicketId);

    if (from === -1) {
        return ids;
    }

    if (!Number.isInteger(targetIndex) || targetIndex < 0 || targetIndex >= ids.length) {
        return ids;
    }

    const target = targetIndex;

    if (target === from) {
        return ids;
    }

    const next = [...ids];
    next.splice(from, 1);
    next.splice(target, 0, ids[from]);

    return next;
};
